import React, { PureComponent } from 'react';

import { Grid, Cell, Section } from 'formlabs-web-components/Grid';
import { Picture } from 'formlabs-web-components/Media';
import { Button, Link } from 'formlabs-web-components/Link';
import { Header } from 'formlabs-web-components/Type';

import bikesImage from '../../../../public/bikes.png';
import glassdoorImage from '../../../../public/glassdoor.png';

import '../../../common/components/navigation/Footer.module.css';

export default class CareersFooter extends PureComponent {
  render() {
    return (
      <div styleName="career-footer">
        <Section hasContainer={true}>
          <Grid direction="x" primaryAlignment="align-center">
            <Cell largeSize={9}>
              <Header level={4} displayAs={4} styles={{ marginBottom: '20px' }}>
                Hear the latest on career opportunities and life at Formlabs.
              </Header>

              <Button
                color={'dark'}
                arrow={'none'}
                url={
                  'https://formlabs.us19.list-manage.com/subscribe/post?u=37488817f7a22f5cb2d0fe74b&id=a8aa3c747e&orig-lang=1'
                }
              >
                {' '}
                <i
                  className="fl-markunread"
                  style={{ fontSize: '1rem', marginRight: '5px' }}
                />{' '}
                Subscribe to our careers newsletter{' '}
              </Button>
              <div styleName="social-icons">
                <Link
                  to={'https://www.facebook.com/Formlabs/'}
                  openInNewWindow={true}
                  aria-label={'Formlabs Facebook page'}
                >
                  <i className="fl-facebook" />
                </Link>
                <Link
                  to={'https://www.twitter.com/formlabs/'}
                  openInNewWindow={true}
                  aria-label={'Formlabs Twitter page'}
                >
                  <i className="fl-twitter" />
                </Link>
                <Link
                  to={'https://www.instagram.com/formlabs/'}
                  openInNewWindow={true}
                  aria-label={'Formlabs Instagram page'}
                >
                  <i className="fl-instagram" />
                </Link>
                <Link
                  to={'https://www.youtube.com/user/formlabs1/'}
                  openInNewWindow={true}
                  aria-label={'Formlabs YouTube page'}
                >
                  <i className="fl-youtube" />
                </Link>
                <Link
                  to={'https://www.linkedin.com/company/formlabs/'}
                  openInNewWindow={true}
                  aria-label={'Formlabs LinkedIn page'}
                >
                  <i className="fl-linkedin" />
                </Link>
              </div>
            </Cell>
            <Cell largeSize={3} />
            <Cell largeSize={8} styles={{ textAlign: 'center' }}>
              <Grid direction="x">
                <Cell mediumSize={24}>
                  <Picture
                    largeImage={bikesImage}
                    imageStyles={{ marginBottom: '35px' }}
                    alt={
                      'League of American Bicycles: Bicycle Friendly Business'
                    }
                  />
                </Cell>
                <Cell mediumSize={24}>
                  <Picture
                    largeImage={glassdoorImage}
                    alt={'Glassdoor 2018 Best Places to Work'}
                  />
                </Cell>
              </Grid>
            </Cell>
          </Grid>
        </Section>
      </div>
    );
  }
}

CareersFooter.propTypes = {};
